/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import { Fragment } from 'react'
import {
  glossaryRow,
  plainDefinition,
  plainDefinitionContainer,
  plainDefinitionLabel,
} from './Glossary.styles'

type GlossaryTerm = {
  documentId?: string | null
  term: string
  definition: string
  slug?: string | null
  plain_definition?: string | null
}

type GlossaryTermItemProps = {
  def: GlossaryTerm
  onRegisterRef?: (slug: string, el: HTMLDivElement | null) => void
}

export const GlossaryTermItem = ({ def, onRegisterRef }: GlossaryTermItemProps) => {
  const theme = useTheme()

  return (
    <Fragment key={def.documentId ?? def.term}>
      <Box
        id={def.slug ?? undefined}
        className={`glossary-row ${def.plain_definition ? '' : 'no-plain'}`}
        css={glossaryRow}
        ref={(el) => {
          if (def.slug) onRegisterRef?.(def.slug, el as HTMLDivElement | null)
        }}
      >
        <Box className="glossary-term">{def.term}</Box>
        <Box className="glossary-definition">{def.definition}</Box>
      </Box>

      {def.plain_definition ? (
        <Box css={plainDefinitionContainer(theme)}>
          <Box css={plainDefinitionLabel(theme)}>Plain English:</Box>
          <Box css={plainDefinition(theme)}>{def.plain_definition}</Box>
        </Box>
      ) : null}
    </Fragment>
  )
}
